import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { settingsRailQuery } from '../api/settingsRail'
import './SettingsZone.css'

/**
 * Etajul al doilea al meniului de setari: ce ECRANE sunt in zona deschisa.
 * Perechea veche: `_partials/settings_rail.php`, incarcat din antet pentru
 * fiecare pagina de setari - deci il primeau si ecranele care n-au rail propriu.
 *
 * In v4 lipsea cu totul. Fiecare ecran isi desena filele lui in stanga si atat:
 * de pe Company nu se putea ajunge la User Accounts, la Authentication sau la
 * Reports fara sa treci prin rotita de fiecare data.
 *
 * ASEZAREA nu se inventeaza aici: `settings_console.css` are deja regulile -
 * rail-ul strans la 64px care se desface la maus (sectiunea 21) si invelisul
 * `od-zone-body` care face loc continutului (sectiunea 16). De-aia numele
 * claselor sunt exact cele din macheta veche, pana la `od-rail-label`.
 *
 * Lista poarta `od-zone-nav`, NU `od-dark-sidebar-nav`: pe a doua sta un
 * ascultator din `public/js/app/app.js` care da `preventDefault()` inainte sa
 * se uite ce s-a apasat, si legaturile astea sunt legaturi adevarate.
 */
export function SettingsZone({ path, children }: { path: string; children: ReactNode }) {
  const rail = useQuery(settingsRailQuery(path))

  /* Fara zona (sau pana vine raspunsul) pagina sta cum sta: un invelis cu
     margine, desenat inaintea rail-ului, ar fi mutat continutul si l-ar fi
     mutat inapoi. */
  if (!rail.data || rail.data.zone === '' || rail.data.items.length === 0) {
    return <>{children}</>
  }

  return (
    <>
      <aside className="od-dark-sidebar">
        <ul className="od-zone-nav">
          <li className="menu-header menu-header-lead">
            <span className="od-rail-label">{rail.data.label}</span>
          </li>
          {rail.data.items.map((item) => (
            <li key={item.label} className={item.active ? 'menu-link active selected' : 'menu-link'}>
              <a href={'/app/' + item.url} title={item.label}>
                <i className={item.icon} aria-hidden="true"></i>
                <span className="od-rail-label">{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </aside>
      <div className="od-zone-body">{children}</div>
    </>
  )
}
